import { render, staticRenderFns } from "./table_data.vue?vue&type=template&id=d632d8f0&scoped=true&"
import script from "./table_data.vue?vue&type=script&lang=js&"
export * from "./table_data.vue?vue&type=script&lang=js&"
import style0 from "./table_data.vue?vue&type=style&index=0&id=d632d8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d632d8f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDataTable,VProgressLinear})
